// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  version: 'DEV',
  key : 92092398948,

  //apiOrigin: 'https://sfa1.mankindpharma.in/Itap_QA/api' // QA ITAP New
  
  apiOrigin: 'https://sfa1.mankindpharma.in/Itap_PRD/api' // PROD ITAP New

  //apiOrigin: 'https://testwsfa.mankindpharma.in/WSFAAPI_ITAP/api' // UAT Old
  // apiOrigin: 'https://testwsfa.mankindpharma.in/WSFAAPI_PREPROD/api' // Pre-Prod
  // apiOrigin: 'https://sfa1.mankindpharma.in/wsfaapi/api' // PROD
  // apiOrigin: 'https://testwsfa.mankindpharma.in/testapi/api' // Dev 
  // apiOrigin: 'https://sfa3.mankindpharma.in/Itap_QA/api' // QA ITAP Temp
    
};



/* ng build --configuration production --output-hashing=all
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

